var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.$store.state.result)?_c('span',[_vm._v("\n\t\t"+_vm._s(_vm._f("commas")(_vm.count))+" "+_vm._s(_vm.entityName)+_vm._s(_vm.count===1?'':'s')+" Found\n\t")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }